// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5eccb620","223":"ecf61147","239":"373adb56","455":"231de394"}[chunkId] + ".chunk.js";
};